import { Fragment } from 'react';
import TemplateModal from './templateModal';
import { useTranslation } from 'react-i18next';

const CreditUsageModal = ({ isVisible, onCancel, onConfirm, currentCredits, price, samplePath }) => {
    const { t } = useTranslation(['confirmModal']);

    const remainingCredits = currentCredits - price;

    return (
        <TemplateModal
            title={t('title.confirm-credit-usage')}
            content={
                <Fragment>
                    <p style={{ margin: '0' }}>{t('message.confirm-credit-usage', { count: price })}</p>
                    <p style={{ margin: '0' }}>
                        {t('message.remaining-credits.part1')} <strong>{remainingCredits}</strong>
                        &nbsp;
                        {t(
                            remainingCredits === 1
                                ? 'message.remaining-credits.part2-single'
                                : remainingCredits >= 2 && remainingCredits <= 4
                                  ? 'message.remaining-credits.part2-plural-2-4'
                                  : 'message.remaining-credits.part2-plural-5-n'
                        )}
                    </p>
                    {samplePath && (
                        <p style={{ margin: '8px 0 0' }}>
                            <a href={samplePath} target="_blank" rel="noopener noreferrer">
                                {t('sample-report')}
                            </a>
                        </p>
                    )}
                </Fragment>
            }
            isVisible={isVisible}
            onCancel={onCancel}
            onConfirm={() => onConfirm({})}
            confirmText={t('buttons.yes')}
            cancelText={t('buttons.no')}
        />
    );
};

export default CreditUsageModal;
